import EventEmitter from "./EventEmitter";
import Palette from "./Palette";
import Utils from "./Utils";
import Switch from "./Switch";

export default class UI extends EventEmitter {
  constructor(container, translations, tracker) {
    super();
    this.container = container;
    this.translations = translations;
    this.tracker = tracker;
    this.isIntro = true;
    this.handler = {
      click: this.onClick.bind(this),
      switchChange: this.onSwitchChange.bind(this),
    };
    // color palettes
    this.color_palette = new Palette();
    // position palette
    this.resetPalettePosition();
    this.setTexts();
    // switch
    this.switch = new Switch(document.querySelector(".switch-wrapper"));
    this.switch.addEventListener("switch_change", this.handler.switchChange);
    container.addEventListener("click", this.handler.click);
  }

  reset() {
    Array.from(this.container.getElementsByTagName("li")).forEach((item) => {
      item.classList.remove("active");
    });
    // hide palette
    document.getElementById("palette").classList.add("hide");
  }
  onClick(e) {
    let button;
    if (e.target.tagName == "path") {
      button = e.target.parentNode.parentNode;
    } else if (e.target.tagName == "svg") {
      button = e.target.parentNode;
    } else {
      button = e.target;
    }
    // console.log(button);
    if (
      !button.classList.contains("deactivated") &&
      !button.classList.contains("panel")
    ) {
      this.reset();
      button.classList.toggle("active");
      this.changeState(button);

      // new tracking on user interaction only
      const state = button.getAttribute("data-name");
      if (this.tracker) this.tracker.track("ui_click", state);
    }
  }

  delegateClick(item) {
    console.log("DELEGATE CLICK", item);
    if (!item.classList.contains("deactivated")) {
      this.reset();
      item.classList.toggle("active");
      this.changeState(item);
    }
  }

  onSwitchChange(state) {
    this.updateUISwitch(state);
    this.raiseEvent("change", ["switch"]);
    if (this.tracker) this.tracker.track("switch", state ? "magic" : "pen");
  }
  updateUISwitch(state) {
    if (state) {
      this.deactivateElement("pen");
      this.activateElement("magic");
      this.force("magic");
    } else {
      this.deactivateElement("magic");
      this.activateElement("pen");
      this.force("pen");
    }
  }
  setTexts() {
    const textElements = document.querySelectorAll("[data-translation-value]");
    textElements.forEach((textElement) => {
      const key = textElement.dataset.translationValue;
      const translatedText = this.translations[key];
      textElement.innerText = translatedText;
    });
  }
  changeState(elem) {
    // automate
    this.state = elem.getAttribute("data-name");
    if (elem.classList.contains("color")) {
      // document.getElementById("palette").style.transform = `translate(calc(${
      //   window.innerWidth - 40
      // }px - 100%), calc(${window.innerHeight / 2}px - 50%))`;
      this.resetPalettePosition();

      // document.getElementById("palette").classList.remove("hide");
      //do not show if we are in the tutorial
      if (!this.isIntro) {
        this.showPalette();
      }
      //this.showPalette();
      this.color_palette.setActiveColor();
      this.state = "color";
    }

    this.raiseEvent("change", [this.state]);
  }
  force(name) {
    Array.from(this.container.getElementsByTagName("li")).forEach((item) => {
      if (item.getAttribute("data-name") == name) {
        // item.click();
        /**
         * SIMULATE A CLICK WITHOUT TRACKING
         */
        this.delegateClick(item);
      }
    });
  }

  hide() {
    this.container.style.opacity = 0;
    this.container.style.pointerEvents = "none";
    // document.getElementById("palette").classList.add("hide");
    this.hidePalette();
    this.hideSwitch();
  }
  show() {
    this.container.style.opacity = 1;
    this.container.style.pointerEvents = "auto";
    // document.getElementById("palette").classList.remove("hide");
  }

  showResultScreenButtons() {
    const ctaContainer = document.querySelector("#cta-container");
    // landscape mobile: only show the buttons without moving them
    if (Utils.isLandscapeMobile()) {
      ctaContainer.classList.remove("invisible");
      return;
    }

    ctaContainer.style.position = "absolute";
    // place them at the bottom of the #wrapper container
    const wrapperPositon = document
      .querySelector("#wrapper")
      .getBoundingClientRect();
    const offsetX = wrapperPositon.x + wrapperPositon.width / 2;
    const offsetY = wrapperPositon.y + wrapperPositon.height;
    const rootContainerOffsetX = 10;
    const rootContainerOffsetY = 10;
    const marginTop = 6;
    ctaContainer.style.left = `${offsetX - rootContainerOffsetX}px`;
    ctaContainer.style.top = `${offsetY - rootContainerOffsetY + marginTop}px`;
    ctaContainer.style.transform = "translateX(-50%)";
    ctaContainer.classList.remove("invisible");
  }

  hideResultScreenButtons() {
    document.querySelector("#cta-container").classList.add("invisible");
  }

  showSwitch(afterBackToEditScreen = false) {
    this.isIntro = false;
    this.switch.show();
    // update magic or pen state
    // this.onSwitchChange(this.switch.switch.getAttribute("aria-checked"));
    // if (this.switch.switch.getAttribute("aria-checked") === "true") {

    // }else{

    // }
    if (!afterBackToEditScreen)
      this.updateUISwitch(
        this.switch.switch.getAttribute("aria-checked") === "true"
      );
  }

  hideSwitch() {
    this.switch.hide();
  }

  showPalette() {
    document.getElementById("palette").classList.remove("hide");
  }
  hidePalette() {
    document.getElementById("palette").classList.add("hide");
  }
  resetPalettePosition() {
    // Mobile
    if (Utils.isSmallOrMediumLayout()) {
      document.getElementById("palette").style.transform = `translate(calc(${
        window.innerWidth / 2
      }px - 50%),10px)`;
      // Also check for mobile landscape here!
      if (Utils.isLandscapeMobile()) {
        // Bottom right on landscape mobile
        const transform =
          "translate(calc(100vw - 100% - 12px), calc(100vh - 100% - 12px))";
        document.getElementById("palette").style.transform = transform;
      }
    } else {
      // Desktop
      if (Utils.isLandscapeMobile()) {
        // Bottom right on landscape mobile
        const transform =
          "translate(calc(100vw - 100% - 12px), calc(100vh - 100% - 12px))";
        document.getElementById("palette").style.transform = transform;
      } else {
        document.getElementById("palette").style.transform = `translate(calc(${
          window.innerWidth / 2
        }px - 50%), 40px)`;
      }
    }
  }
  deactivateElement(name) {
    const element = document.querySelector(`li.${name}`);
    element.classList.add("deactivated");
  }
  activateElement(name) {
    const element = document.querySelector(`li.${name}`);
    element.classList.remove("deactivated");
  }
  //hideElement()
  showElement(element) {
    element.classList.remove("hidden");
  }
  hideElement(element) {
    element.classList.add("hidden");
  }
}
